import { Injectable } from '@angular/core';
import { RoleUser, SupportAccessRequest } from '../models/role';
import { User } from '../models/user';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class UserCalendarService {
	baseUrl = environment.apiEndpoint + '/usercalendar/';

	constructor(private http: HttpClient) { }

	GetCalendarDates(): Observable<any[]> {
		return this.http.get<any[]>(this.baseUrl);
	}

	RemoveCalendarDate(id: string): Observable<any>{
		return this.http.delete(this.baseUrl + id);
	}

	AddCalendarDates(input: any){
		return this.http.post(this.baseUrl, input);
	}

	GetManagerCalendarDates(): Observable<any[]> {
		return this.http.get<any[]>(this.baseUrl + 'manager');
	}

	GetInstanceCalendarDates(): Observable<any[]> {
		return this.http.get<any[]>(this.baseUrl + 'instance');
	}
}
